import { ChangeDetectorRef, Component, EventEmitter, HostListener, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ClientViewModel } from '../../models-views/client.view.model';
import { ProjectViewModel } from '../../models-views/project.view.model';
import { TaskViewModel } from '../../models-views/task.view.model';
import { QuickAddService } from '../../services/quick-add.service';
import { NzTableComponent } from 'ng-zorro-antd/table';
import { Project } from '../../models/project.model';
import { Task } from '../../models/task.model';
import { BehaviorSubject, fromEvent, skip, Subject, takeUntil, throttleTime } from 'rxjs';
import { ConsoleViewModel } from '../../models-views/console.view.modal';
import { AppCommon } from '../../providers/app-common';
import { NzModalService } from 'ng-zorro-antd/modal';
import { ConsoleTabService } from '../../services/console-tab.service';
import { TitleService } from '../../services/title.service';
import { defaultEventImage } from '../../appCommon';

@Component({
  selector: 'app-console-client-tab',
  standalone: false,
  templateUrl: './console-client-tab.component.html',
  styleUrl: './console-client-tab.component.scss'
})
export class ConsoleClientTabComponent {
  @ViewChild('virtualTableP', { static: false }) virtualTableP?: NzTableComponent<Project>;
  @ViewChild('virtualTableT', { static: false }) virtualTableT?: NzTableComponent<Task>;
  defaultEventImage = defaultEventImage
  @Input() tabData: any;
  clientData: any;
  clientDataModel = new BehaviorSubject<any>(undefined);

  isVisible: boolean = false
  isVisiblePOC: boolean = false
  showProjectDetail: boolean = false;
  selectData: any
  selectedType: any
  listOfTasks: any = []
  listOfTaskStatus: any = []
  listOfPriority: any = []
  loading: boolean = true
  loadingMore: boolean = false
  page: number = 1
  page_size: number = 6
  listOfProject: any = []
  projectNext: any
  taskNext: any
  selectedTabIndex: number = 0
  isVisibleAddPoc: boolean = false
  isVisibleAddAddress: boolean = false
  editPocData: any
  addressData: any
  private destroy$ = new Subject<boolean>();
  loggedInUser: any
  isConsolePage: boolean = false;
  recentEvents: any = []

  constructor(private vm: ProjectViewModel, private router: Router, private quickAddService: QuickAddService,
    private vmc: ClientViewModel, private vmt: TaskViewModel, private cvm: ConsoleViewModel,
    private cdr: ChangeDetectorRef, private modal: NzModalService,private titleService: TitleService,
    private activeRouter: ActivatedRoute, private consoleTabService: ConsoleTabService
  ) {
    this.loggedInUser = AppCommon.getloggedInObject().user;

    this.quickAddService.refreshData.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data) {
        this.getData();
      }
    })
    this.vmc.eventResponseModel.subscribe(data => {
      this.recentEvents = data.results
    })
  }

  ngOnInit(): void {
     
    if (this.router.url.includes('/app/console')) {
      this.isConsolePage = true;
    } else{
      this.titleService.setTitle('Client Details');
    }

    if (this.router.url.includes('/app/clients')) {
      const pageID = Number(this.activeRouter.snapshot.paramMap.get('id'));
      this.tabData = { id: pageID, name: `client-details-${pageID}` }
    }
    sessionStorage.setItem('selectedClient', JSON.stringify(this.tabData.id));
    // Subscribe data
    this.vmc.parentConsoleClientTabComponent = this;
    this.subscribeToTabsData();

    // Api calls 
    this.vmt.getTaskStatusList(this.page, 100);
    this.vmt.getPriorityList(this.page, 100);
    this.getData();
  }


  private resizeObserverP?: ResizeObserver;
  private resizeObserverT?: ResizeObserver;

  // The virtual-scroll viewport measures its own size only once, on creation — often before layout
  // has settled, under-rendering rows until something (e.g. a window resize) forces a recheck.
  // A ResizeObserver self-heals regardless of exactly when the size settles.
  private syncVirtualScrollViewportSize(viewport: any, existing?: ResizeObserver): ResizeObserver | undefined {
    existing?.disconnect();
    const el = viewport?.getElementRef().nativeElement;
    if (!viewport || !el || typeof ResizeObserver === 'undefined') {
      return undefined;
    }
    const observer = new ResizeObserver(() => viewport.checkViewportSize());
    observer.observe(el);
    return observer;
  }

  subscribeToTabsData() {
    this.vmc.client.pipe(takeUntil(this.destroy$)).subscribe(this.clientDataModel);
    this.vmt.taskStatusList.pipe(takeUntil(this.destroy$)).subscribe(data => { this.listOfTaskStatus = data.results });
    this.vmt.priorityList.pipe(takeUntil(this.destroy$)).subscribe(data => { this.listOfPriority = data.results });
    this.cvm.projectListData.pipe(takeUntil(this.destroy$)).subscribe(e => {
      this.projectNext = e.next
      // `previous == null` => fresh result set; otherwise append the next page, de-duped by id.
      if (e.previous == null) {
        this.listOfProject = e.results;
        setTimeout(() => {
          this.resizeObserverP = this.syncVirtualScrollViewportSize(this.virtualTableP?.cdkVirtualScrollViewport, this.resizeObserverP);
        });
      } else {
        const seen = new Set(this.listOfProject.map((p: any) => p.id));
        this.listOfProject = [...this.listOfProject, ...e.results.filter((p: any) => !seen.has(p.id))];
      }
      setTimeout(() => {
        this.loading = false
        this.loadingMore = false
      }, 100)
    });

    this.cvm.ClienttaskDataList.pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.taskNext = data.next
      // `previous == null` => fresh result set; otherwise append the next page, de-duped by id.
      if (data.previous == null) {
        this.listOfTasks = data.results;
        setTimeout(() => {
          this.resizeObserverT = this.syncVirtualScrollViewportSize(this.virtualTableT?.cdkVirtualScrollViewport, this.resizeObserverT);
        });
      } else {
        const seen = new Set(this.listOfTasks.map((t: any) => t.id));
        this.listOfTasks = [...this.listOfTasks, ...data.results.filter((t: any) => !seen.has(t.id))];
      }
      setTimeout(() => {
        this.loading = false
        this.loadingMore = false
      }, 100)
    });
  }

  getData() {
    this.loading = true;
    // Fresh load — send both virtual-scroll viewports back to the top before the calls go out.
    this.virtualTableP?.cdkVirtualScrollViewport?.scrollToIndex(0);
    this.virtualTableT?.cdkVirtualScrollViewport?.scrollToIndex(0);
    this.vmc.getClientByID(this.tabData.id, 'app-console-client-tab');
    this.cvm.getProjectList(this.page, this.page_size, this.tabData, 'client');
    this.cvm.getTaskList(this.page, this.page_size, this.tabData, 'client');
    this.vmc.getEvents(1, 10,null,null,this.tabData.id )
  }

  clientDataReceived() {
    this.loading = false;
    this.clientData = this.clientDataModel.value;
    if (this.isConsolePage) {
      this.tabData.name = this.clientData.name;
    }

  }

  // eventdataRecieved(){

  // }

  clientDataReceivedError() {
    this.loading = false;

    if (!this.tabData.name.startsWith('client-details')) {
      // this.router.navigate(['/app/clients'])
      this.modal.confirm({
        nzTitle: 'The client is not available or deleted.',
        nzContent: '<b style="color: red;">Do you want to remove it?</b>',
        nzOkText: 'Yes',
        nzOkType: 'primary',
        nzOkDanger: true,
        nzOnOk: () => this.consoleTabService.removeConsoleTabById(this.tabData.id),
        nzCancelText: 'No',
        nzOnCancel: () => console.log('Cancel')
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tabData'].currentValue) {
      this.cvm.getTaskList(this.page, this.page_size, this.tabData, 'client'),
        this.cvm.getProjectList(this.page, this.page_size, this.tabData, 'client')
    }

  }

  ngAfterViewInit(): void {
    this.virtualTableP?.cdkVirtualScrollViewport?.scrolledIndexChange
      .pipe(takeUntil(this.destroy$), skip(1), throttleTime(300))
      .subscribe((data: number) => {
        if (this.projectNext != null && !this.loadingMore) {
          this.loadingMore = true
          this.page++
          this.cvm.getProjectList(this.page, this.page_size, this.tabData, 'client')
          this.projectNext = null
        }

      });
    this.virtualTableT?.cdkVirtualScrollViewport?.scrolledIndexChange
      .pipe(takeUntil(this.destroy$), skip(1))
      .subscribe((data: number) => {
        if (this.taskNext != null && !this.loadingMore) {
          this.loadingMore = true
          this.page++
          this.cvm.getTaskList(this.page, this.page_size, this.tabData, 'client')
          this.taskNext = null
        }

      });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
    this.resizeObserverP?.disconnect();
    this.resizeObserverT?.disconnect();
    Number(sessionStorage.getItem('selectedClient')) == this.tabData.id &&  sessionStorage.removeItem('selectedClient');
  }

  trackByIndex(_: number, data: Project | Task): number {
    return data.id;
  }


  openWebsite(url: string) {
    window.open(url, '_blank');
  }

  openAddPoc() {
    this.isVisibleAddPoc = true;
    this.editPocData = undefined
  }
  openAddAddress() {
    this.isVisibleAddAddress = true;
    this.addressData = undefined
  }

  getPrimaryPoc(data:any){
  return data.poc_details.filter(poc => poc.type_name === 'Primary').length > 0 ?  data.poc_details.filter(poc => poc.type_name === 'Primary')[0]?.poc_name : 'No Primary POC'

  }

  // closeAddAddress(address: any) {
  //   // const currentAddresses = this.clientForm.get('address')?.value || [];

  //   if (address && !this.addressData) {
  //     // Adding a new address
  //     const newAddress = {
  //       address_field_1: address.address_field_1,
  //       address_field_2: address.address_field_2,
  //       country: address.country,
  //       country_name: address.country_name,
  //       state: address.state,
  //       state_name: address.state_name,
  //       city: address.city,
  //       city_name: address.city_name,
  //       zip_code: address.zip_code,
  //       address_type: address.address_type,
  //       address_type_name: address.address_type_name
  //     };
  //     // this.clientForm.get('address')?.setValue([...currentAddresses, newAddress]);
  //     let formValue = { address:[newAddress]}
  //     formValue['modified_by']  = this.loggedInUser.id
  //     this.vmc.updateClient(formValue)
  //   } else {
  //     // Editing an existing address
  //     // const updatedAddresses = currentAddresses.map((item: any) =>
  //     //   item.id === address.id ? { ...item, ...address } : item
  //     // );
  //     // this.clientForm.get('address')?.setValue(updatedAddresses);
  //   }  
  // }

  // deleteAddress(address: any) {
  //   this.vmc.deleteClientAddress(address.id);
  // }

  deletePOC(poc: any) {
    this.vmc.deletePOC(poc.id);
  }

  updateAddress(data: any) {
    this.addressData = data;
    this.isVisibleAddAddress = true;
  }

  editPOC(poc: any) {
    this.editPocData = poc;
    this.isVisibleAddPoc = true;
  }

  closeAddPocEvents(resp: any) {
    console.log(resp)
    this.isVisibleAddPoc = false;
    if (resp == true) {
      this.getData();
    }
  }

  // closeAddPoc(poc:any){
  //   console.log(poc)
  //   // if (poc && !this.editPocData) {
  //   //   const currentPocs = this.clientForm.get('poc')?.value || [];
  //   //   this.clientForm.get('poc')?.setValue([...currentPocs, poc ]);
  //   // } else if(poc.id) {
  //   //   const currentPocs = this.clientForm.get('poc')?.value || [];
  //   //   const updatedPocs = currentPocs.map((item: any) =>
  //   //     item.id === poc.id ? { ...item, ...poc } : item
  //   //   );
  //   //   this.clientForm.get('poc')?.setValue(updatedPocs);
  //   // } else{
  //   //   const currentPocs = this.clientForm.get('poc')?.value || [];

  //   //   this.clientForm.get('poc')?.setValue([...currentPocs, poc]);
  //   // }
  //   this.isVisibleAddPoc = false;

  // }

  getPriorityColor(priority: string): string {
    switch (priority) {
      case 'High': return 'red';
      case 'Medium': return 'orange';
      case 'Low': return 'blue';
      default: return 'default';
    }
  }

  onTabChange(e: any) {
    // localStorage.setItem('selectedTab', JSON.stringify(e));
    this.selectedTabIndex = e;
  }


  editClient(data: any) {
    this.quickAddService.openQuickUpdate('client', data)
  }

  deleteClient(data: any) {
    if (!data) {
      return
    }
    this.modal.confirm({
      nzTitle: 'Are you sure delete "' + data.name + '"?',
      nzContent: '<b style="color: red;">If you delete this, you will no longer be able restore it.</b>',
      nzOkText: 'Yes',
      nzOkType: 'primary',
      nzOkDanger: true,
      nzOnOk: () => this.vmc.deleteClientByID(data.id),
      nzCancelText: 'No',
      nzOnCancel: () => console.log('Cancel')
    });
  }


  clientDeleted() {
    if (this.tabData.name.startsWith('client-details')) {
      this.router.navigate(['/app/clients']);
    } else {
      this.consoleTabService.removeConsoleTabById(this.tabData.id);
    }
  }


  closeAddAddressEvent(event: any) {
    this.addressData = null;
    this.isVisibleAddAddress = false;
    if (event == true) {
      this.getData();
    }
  }



  goToDetail(task: any, type: string): void {
    this.selectData = task;
    this.selectedType = type;
    setTimeout(() => {
      this.showProjectDetail = true;
    }, 500);

  }

  goToProjectDetail(data: any, type: string): void {
    this.selectData = data
    this.selectedType = type
    setTimeout(() => {
      this.showProjectDetail = true;
    }, 500);
  }

  closeProjectDetail() {
    this.showProjectDetail = false;
  }

  formatIdToFourDigits(id: number, str: string): string {
    return id ? str + id.toString().padStart(4, '0') : '';
  }


  getStatusColor(status: number): string {
    if (this.listOfTaskStatus) {
      return status ? this.listOfTaskStatus.filter(e => e.id == status)[0].hexcolor : 'default';
    } else {
      return 'default';
    }
  }


  getTaskPriorityName(id: number) {
    if (this.listOfPriority) {
      return id ? this.listOfPriority.filter(e => e.id == id)[0]?.name : ''
    }
  }


  showPOCModal(): void {
    this.isVisiblePOC = true;
  }

  closePOCModal(e: any): void {
    this.isVisiblePOC = false;
    if (e == true) {
      this.getData();
    }
  }

  pocDeletedEvent(e: any) {
    if (e == true) {
      this.getData();
    }
  }

  showModal(): void {
    this.isVisible = true;
  }

  handleCancel(e: any): void {
    this.isVisible = false;
    if (e == true) {
      this.getData();
    }
  }

  goToTaskDetailModal(data: any) {
    this.showProjectDetail = false;
    this.selectData = data
    this.selectedType = 'task'
    this.cdr.detectChanges();
    this.showProjectDetail = true;
  }

  getIcon(client: any) {
    if (!client) {
      return
    }
    const thumbnail = client.thumbnail
    if (thumbnail) {
      return thumbnail
    }
    return AppCommon.getDicebearIcon(client.name[0]);
  }

  getBase64Image(data: any) {
    if (!data) {
      return undefined;
    }
    return "data:image/png;base64," + data;
  }


  get formattedAddress(): string {
    const addr = this.clientData?.address?.[0];
    if (!addr) return '';

    return [
      addr.address_field_1,
      addr.address_field_2,
      addr.city_name,
      addr.state_name,
      addr.zip_code,
      addr.country_name
    ]
      .filter(part => !!part)
      .join(', ');
  }

}
